import styled from 'styled-components';
import { white } from '../../../../style/colors';

export const Card = styled.div`
  background: ${white};
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
  margin-bottom: 24px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: ${(props) => (props.isExpanded ? '16px' : '0')};
  margin-bottom: ${(props) => (props.isExpanded ? '20px' : '0')};
  border-bottom: ${(props) => (props.isExpanded ? '2px solid #f3f4f6' : 'none')};
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;

  &:hover {
    background: rgba(0, 0, 0, 0.02);
    margin: -8px -12px;
    padding: 8px 12px;
    padding-bottom: ${(props) => (props.isExpanded ? '24px' : '8px')};
    border-radius: 8px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const ExpandIcon = styled.i`
  font-size: 20px;
  color: #6b7280;
  transition: transform 0.2s;
  transform: rotate(${(props) => (props.isExpanded ? '0deg' : '-90deg')});
`;

export const Title = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`;

export const Count = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  background: #f3f4f6;
  padding: 4px 12px;
  border-radius: 12px;
`;

export const Content = styled.div`
  max-height: ${(props) => (props.isExpanded ? '10000px' : '0')};
  opacity: ${(props) => (props.isExpanded ? '1' : '0')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out, opacity 0.2s ease-in-out;
`;

export const DocumentsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
`;
